import {motion} from "framer-motion";
import CategoryButton from "./CategoryButton";
import {FoodCategory} from "../../../types";
import {useStateValue} from "../../context/StateProvider";

const Filters = ({filter, setFilter}: { filter: string, setFilter: any }) => {
    const [{categories}] = useStateValue();
    return (
        <motion.div
            initial={{opacity: 0, x: 200}}
            animate={{opacity: 1, x: 0}}
            exit={{opacity: 0, x: 200}}
            className={`
        w-full
        flex items-center
        justify-start
        gap-3 md:gap-5
        py-4
        px-4
        overflow-x-auto
        overflow-y-hidden
        scroll-smooth
        snap-x
        snap-mandatory
        scrollbar-thin
        filters-scroll
    `}
        >
            <CategoryButton category={{id: 666, name: "Все Меню", urlParam: "all"}} filter={filter}
                            setFilter={setFilter}/>
            {
                categories.map((category: FoodCategory) => {
                    return <CategoryButton key={category.id} category={category} filter={filter} setFilter={setFilter}/>
                })
            }
        </motion.div>
    );
};

export default Filters;
